module.exports = "https://static.zego.com/_next/static/images/EsElPais-9eeeed77eebc3c08022f1698c3e122a5.svg";